import type {
  GraphUrlRequestBody,
  GraphUrlResponseBody,
} from '@ipfabric/utils';
import { exitTopologyPresetEditMode } from 'components/Graph/commands/settings/exitTopologyPresetEditMode';
import type { GraphCommandFactory } from '../model/GraphCommandContext';
import { createGraphViewRequestBody } from './viewHelpers/createGraphViewRequestBody';

export const shareView: GraphCommandFactory =
  (cmdContext, dispatch) => async () => {
    const { snapshotId } = cmdContext.getState();

    dispatch(exitTopologyPresetEditMode);

    const sharedView = await cmdContext.api.request<
      GraphUrlResponseBody,
      GraphUrlRequestBody
    >({
      url: '/graphs/urls',
      method: 'POST',
      data: {
        graphView: createGraphViewRequestBody(
          'Shared view',
          cmdContext.getState(),
        ),
        snapshot: snapshotId,
      },
    });

    cmdContext.updateState((draft) => {
      draft.sharedViewId = sharedView.id;
    });
  };
